import React, { useEffect, useState } from "react";
import TextMedium from "../TextComponent/TextMedium";
import { useSelector } from "react-redux";

let codeStatus = [];

export default function CardTotalConnected({ title1, title2, level }) {
  const LoginCompleteReducer = useSelector((state) => state.ipcurrent);
  const usersReduce = useSelector((state) => state.agents);
  const managerStatusOperators = useSelector(
    (state) => state.datamanagerstatusoperators
  );
  const FiltersManager = useSelector((state) => state.filtersmanager);
  const GroupsPermissionSupervisor = useSelector(
    (state) => state.grouppermissionsupervisor
  );
  const [totalOperators, setTotalOperators] = useState(0);
  const [connected, setConnected] = useState(0);
  const [inactive, setInactive] = useState(0);

  const someStyle = {
    "--width": `${((connected * 100) / totalOperators).toFixed(2)}%`,
    "--level": `${((connected * 100) / totalOperators).toFixed(2) / 2}%`,
  };

  const someStyleTwo = {
    "--width": "50%",
    "--level": "50%",
  };

  const someStyleThree = {
    "--width": "0%",
    "--level": "0%",
  };

  useEffect(() => {
    let data = [];
    let groupsPermission = [];
    let inactive = 0;
    if (FiltersManager.is_active) {
      let beforeIsFilter = usersReduce;
      codeStatus = [];

      beforeIsFilter = beforeIsFilter.filter((filt) =>
        FiltersManager.filter_manager_group.includes(filt.id_grupo)
      );

      let tempIdle = FiltersManager.filter_manager_status.filter(
        (filt) => filt === 1
      );
      let tempAnswer = FiltersManager.filter_manager_status.filter(
        (filt) => filt === 2
      );
      let tempReason = FiltersManager.filter_manager_status.filter(
        (filt) => filt === 3
      );
      let tempBlock = FiltersManager.filter_manager_status.filter(
        (filt) => filt === 4
      );
      let tempOff = FiltersManager.filter_manager_status.filter(
        (filt) => filt === 5
      );
      let tempAcw = FiltersManager.filter_manager_status.filter(
        (filt) => filt === 6
      );

      if (tempIdle.length !== 0) {
        codeStatus.push("LV");
      }

      if (tempAnswer.length !== 0) {
        codeStatus.push("AT", "ATOS", "RV", "CHND");
      }

      if (tempReason.length !== 0) {
        codeStatus.push("BQ");
      }

      if (tempBlock.length !== 0) {
        codeStatus.push("BQSUPER");
      }

      if (tempOff.length !== 0) {
        codeStatus.push("null");
      }

      if (tempAcw.length !== 0) {
        codeStatus.push("ACW");
      }

      groupsPermission = GroupsPermissionSupervisor.map(
        (group) => group.usergroup
      );

      beforeIsFilter = beforeIsFilter.filter((filt) =>
        codeStatus.includes(filt.status, filt.status_sip)
      );

      beforeIsFilter = beforeIsFilter.filter((filt) =>
        groupsPermission.includes(filt.id_grupo)
      );

      for (const user of beforeIsFilter) {
        if (
          (user.status === null && user.status_sip === null) ||
          (user.status === "null" && user.status_sip === "null")
        ) {
          inactive = inactive + 1;
        }
      }

      setTotalOperators(beforeIsFilter.length);
      setInactive(inactive);
      setConnected(beforeIsFilter.length - inactive);
    }
  }, [
    usersReduce,
    FiltersManager,
    GroupsPermissionSupervisor,
    managerStatusOperators,
  ]);

  return (
    <div className="manager-container__level-service total-connected">
      <div className="manager-container__level-service__title">
        <TextMedium text={title1} color="gray" />
      </div>
      <div className="manager-container__level-service__progress" datacustom>
        {LoginCompleteReducer.isLoginComplete ? (
          totalOperators !== 0 ? (
            <div className="progress-bar" style={someStyle}>
              {connected > 0 && (
                <div className="progress-bar__title">
                  <TextMedium text={`${connected}`} color="white" />
                </div>
              )}
              {inactive > 0 && (
                <div className="progress-bar__title inactive">
                  <TextMedium text={`${inactive}`} color="gray" />
                </div>
              )}
            </div>
          ) : (
            <div className="progress-bar-two" style={someStyleThree}></div>
          )
        ) : (
          <div className="progress-bar-two" style={someStyleTwo}></div>
        )}
      </div>
      {inactive > 0 && (
        <div
          className="manager-container__level-service__title"
          style={{ textAlign: "center" }}
        >
          <TextMedium text={title2} color="gray" />
        </div>
      )}
    </div>
  );
}
